import store from '../store';
import api from '../../api';
import { handleResponse } from '../../bae/common';
import { showError } from '../../elements/Toasts/toastActions';
import strings from '../../lang/lang';
import actionTypes from './actionTypes';
// import { loadSwaggerApi } from '../swaggerApi/swaggerApiActions';
// import { checkPathMatch } from '../../utils/helpers';

export async function loadInformation({ pathname, section }) {
  try {
    store.dispatch({
      type: actionTypes.INFO_LOAD,
    });
    const result = await api.portal.getApiList();
    if (Math.floor(result.status / 100) === 2) {
      const response = await handleResponse(result);

      store.dispatch({
        type: actionTypes.INFO_SUCCESS,
        payload: response,
      });

      // if (checkPathMatch(section, pathname)) {
      //   let url = pathname;
      //   url = url.replace(/\/$/, '');
      //   let id = 'identity';
      //   if (url.split('/').pop() !== 'apis') {
      //     id = url.split('/').pop();
      //   }
      //   const item = response.data.find((c) => c.id === id);
      //   loadSwaggerApi(item);
      // }
    } else {
      const response = await result.json();
      store.dispatch({
        type: actionTypes.INFO_FAILED,
      });
      showError(response.message);
    }
  } catch (e) {
    store.dispatch({
      type: actionTypes.INFO_FAILED,
    });
    console.log('error', e);

    showError(strings.apiCatalogue.errors.retrievingApiData);
  }
}
